<template>
    <div class="container sticky-top-cust">
        <div class="card">
            <div class="card-body p-2">
                <div class="row">
                    <div class="col-sm-6 mb-1">
                        <input v-model.trim="keyword"  type="text" class="form-control" maxlength="100" spellcheck=false placeholder="会社名・会社Group・要員ID・氏名"></input>
                    </div>
                    <div class="col-sm-6 d-flex">
                        <div class="mr-1 flex-fill">
                            <input v-model.trim="freeword"  type="text" class="form-control" maxlength="100" spellcheck=false placeholder="フリーキーワード"></input>
                        </div>
                        <div class="px-1">
                            <button type="button" class="btn btn-success" @click="addResume">
                                <i class="fa fa-plus-circle"></i>
                            </button>
                        </div>
                        <div class="px-1">
                            <button type="button" class="btn btn-primary" @click="toggleMailGroup">
                                <i class="fas fa-filter"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- メールグループ -->
                <div class="collapse" id="mail-group">
                    <mail-group class="mt-1" :list="getTechResume.data.mail_group" type="2" ></mail-group>
                    <div class="mt-2">
                        <small class="text-muted">※本日、既に個別送信済みの要員は一括送信対象外になる</small>
                    </div>
                </div>
            </div>
        </div>


        <div v-show="hasSearch" class="list" :style="{height:wrapperHeight + 'px'}">
            <div class="wrapper" ref="wrapper">
                <div class="card">
                    <ul class="list-group list-group-flush border-bottom-0">
                        <li class="list-group-item px-2" v-for="item in list" :key="item.id">
                            <!-- 技術者カード -->
                            <row :item="item" ></row>
                        </li>
                        <li v-show="hasNoSearchData" class="list-group-item text-center text-muted">該当するデータがありません</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import {mapGetters} from 'vuex'
    import MailGroup from 'pages/commons/modal/selectMailGroup/SelectMailGroup'
    import Row from './Row'

    export default {
        components: {
            MailGroup,
            Row
        },
        data () {
            return {
                keyword: '',
                freeword: '',
                list:[],
                time: null,
                wrapperHeight: $(window).height() - 167,
                from: this.$route.params.id
            }
        },
        mounted () {
            this.scroll = new BScroll(this.$refs.wrapper, {click:true})
        },
        activated () {
            this.findData()
            this.scroll = new BScroll(this.$refs.wrapper, {click:true})
        },
        watch: {
            keyword () {
                this.findData()
            },
            freeword () {
                this.findData()
            },
            getTechResumeHasChangeForInputBarStatus (status) {
                if (status == 2) {
                    this.findData()
                }
            }
        },
        computed: {
            hasSearch () {
                return this.keyword || this.freeword
            },
            hasNoSearchData () {
                return !this.list.length
            },
            ...mapGetters(['getTechResume', 'getTechResumeHasChangeForInputBarStatus'])
        },
        methods: {
            addResume () {
                this.$parent.addResume()
            },
            toggleMailGroup () {
                if ($('#mail-group').hasClass('show')) {
                    $('#mail-group').collapse('hide')
                } else {
                    $('#mail-group').collapse('show')
                }
            },
            findData () {
                if (!this.hasSearch) {
                    this.list = []
                    this.$parent.showList()
                    return
                }

                this.$parent.hideList()

                if (this.timer) {
                    clearTimeout(this.timer)
                }

                this.timer = setTimeout(()=> {
                    let result = []
                    if (this.hasSearch) {
                        result = this.getTechResume.data.resume.filter((item)=> {
                                let group = item.user_group
                                let groupNm = item.user_group_nm ? item.user_group_nm : ""
                                let id = (item.id).toString()
                                let techNm = item.name
                                let summary = item.summary ? item.summary : ""

                                let resKey = this.keyword ? group.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1 
                                                || groupNm.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1 
                                                || id.indexOf(this.keyword.toLowerCase()) != -1
                                                || techNm.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1 : true

                                let idxAnd = this.freeword.indexOf(" ") != -1 ? true : false
                                let idxOr = this.freeword.indexOf("|") != -1 ? true : false
                                let arr = []
                                let mark = ''
                                if (idxAnd) {
                                    arr = this.freeword.toLowerCase().split(" ")
                                    mark = 'and'
                                } else if (idxAnd == false && idxOr) {
                                    arr = this.freeword.toLowerCase().split("|")
                                    mark = 'or'
                                }

                                let resFree = true
                                if (arr.length > 1) {
                                    let resStr = [] 
                                    for (let key of arr) {
                                        resStr.push(summary.toLowerCase().indexOf(key) != -1) 
                                    }
                                    resFree = mark == 'and' ? !resStr.includes(false) : resStr.includes(true)
                                } else {
                                    resFree = this.freeword ? summary.toLowerCase().indexOf(this.freeword.toLowerCase()) != -1 : true
                                }

                                return resKey && resFree
                            }
                        )
                    }
                    this.list = result
                }, 200)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .list
        position: relative
        .wrapper
            overflow: hidden
            position: absolute
            top: 0.5rem
            left: 0
            right: 0
            bottom: 0
    .sticky-top-cust 
        position: sticky;
        top: 0;
        z-index: 1000;
</style>
